"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCatcher = void 0;
var react_1 = __importDefault(require("react"));
var Logger_1 = require("../../utils/Logger");
var ErrorCatcher = /** @class */ (function (_super) {
    __extends(ErrorCatcher, _super);
    function ErrorCatcher(props) {
        var _this = _super.call(this, props) || this;
        if (props.message) {
            Logger_1.Logger.warn(_this.props.message || '');
        }
        _this.state = { hasError: false };
        return _this;
    }
    ErrorCatcher.prototype.componentDidCatch = function (error, info) {
        this.setState({ hasError: true, error: error, info: info });
        Logger_1.Logger.error("Error: ".concat(error.toString(), ", Info: ").concat(info.toString()));
    };
    ErrorCatcher.prototype.render = function () {
        // TODO: Display something on error https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems?id=849134
        if (this.state.hasError) {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, this.state.error ? this.state.error.message : null),
                react_1.default.createElement("pre", null, this.state.info ? this.state.info.componentStack : null)));
        }
        return this.props.children;
    };
    return ErrorCatcher;
}(react_1.default.Component));
exports.ErrorCatcher = ErrorCatcher;
//# sourceMappingURL=ErrorCatcher.js.map